/* eslint-disable i18next/no-literal-string -- const enum definitions are the source of truth */
import type {Instant, UUID} from './common'

export const EscalationLevel = {
    NONE: 'NONE',
    REMINDED: 'REMINDED',
    FINAL_REMINDED: 'FINAL_REMINDED',
    ESCALATED_TO_MANAGER: 'ESCALATED_TO_MANAGER',
    ESCALATED_TO_PLATFORM_OWNER: 'ESCALATED_TO_PLATFORM_OWNER',
    CHAIN_CLOSED: 'CHAIN_CLOSED',
} as const
export type EscalationLevel = typeof EscalationLevel[keyof typeof EscalationLevel]

export const EscalationStepType = {
    ACCESS_REQUEST: 'ACCESS_REQUEST',
    FUNCTION_GROUP_REQUEST: 'FUNCTION_GROUP_REQUEST',
    AUTOASSIGN_REQUEST: 'AUTOASSIGN_REQUEST',
    RESTRICTION_RULE_REQUEST: 'RESTRICTION_RULE_REQUEST',
} as const
export type EscalationStepType = typeof EscalationStepType[keyof typeof EscalationStepType]

export const EscalationEventType = {
    REMINDED: 'REMINDED',
    FINAL_REMINDED: 'FINAL_REMINDED',
    ESCALATED_TO_MANAGER: 'ESCALATED_TO_MANAGER',
    ESCALATED_TO_PLATFORM_OWNER: 'ESCALATED_TO_PLATFORM_OWNER',
    CHAIN_CLOSED: 'CHAIN_CLOSED',
} as const
export type EscalationEventType = typeof EscalationEventType[keyof typeof EscalationEventType]

export const ManagerTarget = {
    APPROVER_MANAGER: 'APPROVER_MANAGER',
    OBJECT_OWNER_MANAGER: 'OBJECT_OWNER_MANAGER',
} as const
export type ManagerTarget = typeof ManagerTarget[keyof typeof ManagerTarget]

export const EscalationRequestType = {
    ACCESS_REQUEST: 'ACCESS_REQUEST',
    FUNCTION_GROUP_REQUEST: 'FUNCTION_GROUP_REQUEST',
    AUTOASSIGN_REQUEST: 'AUTOASSIGN_REQUEST',
    RESTRICTION_RULE_REQUEST: 'RESTRICTION_RULE_REQUEST',
    DEFAULT: 'DEFAULT',
} as const
export type EscalationRequestType = typeof EscalationRequestType[keyof typeof EscalationRequestType]

export interface EscalationThreshold {
    id: UUID
    code: string
    requestType: EscalationRequestType
    riskLevelCode: string | null
    reminderDays: number
    finalReminderDays: number
    escalateToManagerDays: number
    escalateToPlatformOwnerDays: number
    managerTarget: ManagerTarget
    platformOwnerIdentityId: UUID | null
    platformOwnerName: string | null
    active: boolean
    referencedByActiveSnapshots: number
    version: number
    createdAt: Instant
    updatedAt: Instant
}

export interface EscalationEvent {
    id: UUID
    approvalStepId: UUID
    stepType: EscalationStepType
    eventType: EscalationEventType
    firedAt: Instant
    recipientIdentityId: UUID | null
    recipientName: string | null
    thresholdId: UUID | null
    note: string | null
}

export interface UpdateEscalationThresholdRequest {
    reminderDays: number
    finalReminderDays: number
    escalateToManagerDays: number
    escalateToPlatformOwnerDays: number
    managerTarget: ManagerTarget
    platformOwnerIdentityId: UUID | null
    active: boolean
    version: number
}
